import {
  PieChart,
  Pie,
  Tooltip,
  Legend,
  Cell,
  ResponsiveContainer,
} from "recharts";
import { useEffect, useState } from "react";

const COLORS = ["#00C49F", "#FF4D4F", "#A94A4A", "#C08552", "#F08080", "#FF6347"];

export default function ReusablePieChart({
  data = [],
  type = "normal",
  isAnimationActive = true,
}) {
  const isDonut = type === "rounded";

  //  RESPONSIVE STATE
  const [isMobile, setIsMobile] = useState(window.innerWidth < 480);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 480);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ INSIDE LABEL (for solid Pie)
  const renderInsideLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    name,
    value,
    percent,

  }) => {
    if (percent < 0.05) return null;

    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) / 2;

    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="#fff"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={isMobile ? 10 : 12}
        fontWeight="bold"
      >
        <tspan x={x} dy="-0.2em">
          {isMobile && name.length > 5 ? name.slice(0, 5) + ".." : name}
        </tspan>
        <tspan
          x={x}
          dy="1.2em"
          fontSize={isMobile ? 9 : 10}
          fontWeight="normal"
        >
          {value}
        </tspan>
      </text>
    );
  };

  // ✅ OUTSIDE LABEL (for Donut)
  const renderOutsideLabel = (props) => {
    const { name, value, percent } = props;
    if (percent < 0.01) return "";
    return `${name} (${value})`;
  };

  return (
    <div className="chart-wrapper">
      <ResponsiveContainer width="100%" height={isMobile ? 220 : 300}>
        <PieChart
          margin={{
            top: 20,
            right: 20,
            left: 20,
            bottom: 20,
          }}
        >
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            isAnimationActive={isAnimationActive}
            innerRadius={isDonut ? "60%" : 0}
            outerRadius={isDonut ? "85%" : "90%"}
            cornerRadius="5px"
            paddingAngle={isDonut ? 5 : 0}
            stroke="none"
            label={isMobile ? false : renderOutsideLabel}
            labelLine={!isMobile}
          >
            {data.map((entry, index) => (
              <Cell
                key={index}
                fill={entry.fill || COLORS[index % COLORS.length]}
                stroke="none"
              />
            ))}
          </Pie>

          <Tooltip
            contentStyle={{
              backgroundColor: "#001b0e",
              border: "1px solid rgb(252, 68, 32)",
              borderRadius: "8px",
              color: "#fff",
            }}
            itemStyle={{ color: "#fff" }}
          />

          <Legend
            layout="horizontal"
            align="center"
            verticalAlign="bottom"
            iconType="rect"
            wrapperStyle={{
              fontSize: "11px",
              paddingTop: "20px",
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
